

import {
    Component,
    OnInit,
  } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
  import { NGXLogger } from "ngx-logger";
  import { MessageService } from "primeng/api";
  
  import {
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";
  import { Subject } from "rxjs";
import { Pratica } from "src/app/models/pratica.model";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { GoogleStorageService } from "src/app/services/googleStorage.service";
import { PraticheService } from "src/app/services/pratiche.service";
import { environment } from "src/environments/environment";

  

@Component({
    selector: "component-completa-pratica-fase3_bando2",
    templateUrl: "./dialog-completa-pratica.component.html",
    styleUrls: ["../fase3.bando2.component.css"],
  })
  export class CompletaFase3Bando2 implements OnInit {
    protected _onDestroy = new Subject<void>();
    protected praticaFromFirestore: PraticaFlowdy2_Firestore;
    protected pratica: Pratica;
    protected completaPraticaForm: FormGroup;

    protected computoMetricoFile: File = null;
    protected isComputoMetricoUploaded: boolean = false;
    protected isLoading: boolean = false;
    protected isTipoD:Boolean = false;

    private collection_pratiche:string = environment.firebase.collection_pratiche;

    constructor(
      private logger: NGXLogger,
      public dialogRef: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private googleStorageService: GoogleStorageService,
      private formBuilder: FormBuilder,
      private praticheService:PraticheService,
      private firestoreService:AngularFirestore,
      private messageService:MessageService,


    ) {
      this.pratica              = this.config.data.pratica;
      this.praticaFromFirestore = this.config.data.praticaFromFirestore;
      this.completaPraticaForm  = this.formBuilder.group({
            ordineEsecuzione: [this.praticaFromFirestore.ordineEsecuzione, [Validators.required]],
            nomePerInvio:     [this.pratica.codiceInvio, [Validators.required]],
          });
      if(this.praticaFromFirestore.tipoSedeEffettiva.endsWith('D')){
        this.isTipoD = true;
      }
      this.logger.info("ON INIT @ COMPLETA PRATICA FASE 3 BANDO 2 --> "+ this.praticaFromFirestore.tipoSedeEffettiva + " isTipoD: "+ this.isTipoD);
    }

    ngOnInit(): void {
    }

    onComputoMetricoUpload($event) {
      this.isComputoMetricoUploaded = true;
      this.computoMetricoFile = $event.files[0]; 
      this.logger.info(" onComputoMetricoUpload" + this.computoMetricoFile.name);
  
    }
    onComputoMetricoRemove() {
      this.isComputoMetricoUploaded = false; 
    }

    conferma(conferma: boolean) {
      if (!conferma) {
        this.dialogRef.close({ success: false });
      } else {
        this.logger.info("+++ COMPLETA PRATICA +++");
        
        this.logger.info(this.pratica);

        this.pratica.datiFase3.ordineEsecuzione = this.completaPraticaForm.value.ordineEsecuzione;
        this.pratica.codiceInvio                 = this.completaPraticaForm.value.nomePerInvio;
        this.isLoading = true;
        this.praticheService.comunicaOrdineEsecuzione(this.pratica).subscribe(res =>{
      
          this.logger.info("OK SALVATAGGIO ORDINE ESECUZIONE");
            //2) carico i file se sono stati passati
            this.praticheService.completaPratica(this.pratica.id.valueOf()).subscribe(res =>{
               if(this.isComputoMetricoUploaded){
           
                const fileName = this.praticaFromFirestore.cui + "/IN/FASE_3/file/" + this.praticaFromFirestore.codiceRegione+"_F_CMT_03_0.xlsx" ;
    
                this.googleStorageService
                .uploadFileScuolaToGoogleStorage(this.computoMetricoFile, fileName)
                .then((uploadRes) => { 
                  const collectionRef = this.firestoreService.collection(this.collection_pratiche);
                  const documentRef = collectionRef.doc( this.praticaFromFirestore.cui);
                  const updatedData = { computoMetricoUploaded: true };
                  documentRef
                    .update(updatedData)
                    .then(() => {
                     
                    })
                    .catch((error) => {
                     // this.showSpinner = false;
                      this.logger.error(
                        "ERRORE AGGIORNATO CAMPO computoMetricoUploaded SU FIRESTORE"
                      );
                      this.isLoading = false;
                    });
                })
                .catch((errore) => {
                  this.isLoading = false;

                  this.messageService.add({
                    severity: "info",
                   summary: "Errore" , life:10000,
                    detail: "Errore in fase di caricamento del computo metrico!",
                    
                  });
                  this.isLoading = false;

                  this.dialogRef.close({ success: false });
                });
              }  
      
              this.dialogRef.close({ success: true });
            });
          });
      } 
    }
  
  }